import { Editor } from '@tiptap/core';
import { buildExtensions } from './extensions';

/**
 * Headless helpers. Markdown that goes through the editor comes back in a
 * canonical form (list markers, table padding, spacing, escaping). Running the
 * *base* and *theirs* versions through the same normalization before a
 * three-way merge keeps formatting noise out of the diff so only real edits
 * show up.
 */
let headless: Editor | null = null;

function getHeadless(): Editor {
  if (!headless) {
    headless = new Editor({ element: null as unknown as HTMLElement, extensions: buildExtensions(null), content: '', contentType: 'markdown' });
  }
  return headless;
}

/**
 * Post-processing applied to everything the serializer emits: collapse runs
 * of blank lines (outside fenced code) and trim the document edges. The
 * table serializer in particular pads with extra newlines.
 */
export function tidyMarkdown(md: string): string {
  const lines = md.split('\n');
  const out: string[] = [];
  let inFence = false;
  let blankRun = 0;
  for (const line of lines) {
    if (/^\s*(```|~~~)/.test(line)) {
      inFence = !inFence;
      blankRun = 0;
      out.push(line);
      continue;
    }
    if (!inFence && line.trim() === '') {
      blankRun += 1;
      if (blankRun > 1) continue;
      out.push('');
      continue;
    }
    blankRun = 0;
    out.push(line);
  }
  return out.join('\n').replace(/^\n+/, '').replace(/\n+$/, '');
}

export function editorMarkdown(editor: Editor): string {
  return tidyMarkdown(editor.getMarkdown());
}

export function normalizeMarkdown(markdown: string): string {
  const ed = getHeadless();
  ed.commands.setContent(markdown, { contentType: 'markdown', emitUpdate: false });
  return editorMarkdown(ed);
}

export function markdownToJson(markdown: string) {
  const ed = getHeadless();
  ed.commands.setContent(markdown, { contentType: 'markdown', emitUpdate: false });
  return ed.getJSON();
}
